/**
 * Single source of truth for the license tiers staff can issue.
 *
 * Owner decision 2026-10-12: free, standard, organization, enterprise, in this
 * order. KEEP IN SYNC with AllowedTiers in console/services/license/service.go,
 * which rejects any other tier when issuing. To add a tier, add it in BOTH
 * places (and the mcp-server / CLI help text). Existing licenses may hold other
 * strings; display them as-is and never offer them here.
 *
 * Enterprise differs from organization only in that it allows a customer-hosted
 * data plane. That is not enforced by any entitlement check yet.
 */
export interface TierOption {
  value: string;
  label: string;
  description: string;
}

export const TIER_OPTIONS: TierOption[] = [
  { value: "free", label: "Free", description: "Free or trial option." },
  { value: "standard", label: "Standard", description: "Individual paid tier." },
  { value: "organization", label: "Organization", description: "Multi-user organization tier." },
  { value: "enterprise", label: "Enterprise", description: "Organization tier that allows a customer-hosted data plane." },
];

export const DEFAULT_TIER = "standard";

export function tierLabel(value: string): string {
  return TIER_OPTIONS.find((t) => t.value === value)?.label ?? value;
}
